"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navEnUS = void 0;
/** 与 NavNode.msg 路径一致；英文与 Vue CloudPods 侧栏历史文案对齐 */
exports.navEnUS = {
    catalog: {
        ml: 'MLOps',
        maasServiceNav: 'Model Service',
        aiAppBuild: 'AI App Builder',
    },
    aiApp: {
        knowledgeBase: 'Knowledge Base',
        appBuild: 'App Builder',
        appMarket: 'App Market',
    },
    mlops: {
        overview: 'Overview',
        aiMarket: 'AI Market',
        computeMarket: 'Compute Market',
        trainAndInference: 'Training & Inference',
        containerInstance: 'Container Instance',
        trainTask: 'Training Task',
        trainTemplate: 'Training Template',
        inferenceService: 'Inference Service',
        aiAssets: 'AI Assets',
        dataset: 'Dataset',
        modelManage: 'Model Management',
        containerImage: 'Container Image',
        repository: 'Repository',
        diskStorage: 'Disk Storage',
        resourceManage: 'Resource Management',
        dedicatedResource: 'Dedicated Resources',
        resourceQuota: 'Resource Quota',
        resourceMonitor: 'Resource Monitor',
        resourceAudit: 'Resource Audit',
        systemSetting: 'System Settings',
        resourceDashboard: 'Resource dashboard',
        computeCluster: 'Compute Cluster',
        storageCluster: 'Storage Cluster',
    },
    maas: {
        modelSquareSection: 'Model Market',
        modelSquare: 'Model Market',
        experienceCenter: 'Experience Center',
        serviceManage: 'Service Management',
        usageStatistics: 'Usage Statistics',
        servicePrice: 'Service Price',
        apiKey: 'API Key',
        systemSetting: 'System Settings',
        modelServiceSetting: 'Model Service',
    },
    bill: {
        feeCenter: 'Bills',
        accountOverview: 'Overview',
        fundManage: 'Fund Management',
        transactionDetail: 'Fund Details',
        rechargeRemit: 'Recharge',
        transactionHistory: 'History',
        orderManage: 'Order Management',
        myOrder: 'My Orders',
        billManage: 'Bill Management',
        billOverview: 'Bill Overview',
        billDetail: 'Bill Details',
        costBill: 'Cost Bill',
        resourceUsage: 'Resource Usage',
        invoiceManage: 'Invoices',
        invoices: 'Invoices',
        userRights: 'User Rights',
        couponCenter: 'Coupons',
        adminManage: 'Admin Management',
        accountRecharge: 'Account Recharge',
        adminOrderManage: 'Order Management',
        adminProductManage: 'Products',
        productPromotionManage: 'Promotions',
        couponManage: 'Coupons',
        invoiceManageAdmin: 'Invoices',
    },
};
